module.exports = __webpack_public_path__ + "img/home_slider_17.ec14ef71.jpg";